import Chart from "react-apexcharts";

const RadarChart = (props) => {
  const { series, options, height = "100%", width = "100%" } = props;

  return (
    <Chart
      options={options}
      type="radar"
      width={width}
      height={height}
      series={series}
    />
  );
};

export default RadarChart;


